module.exports = __webpack_public_path__ + "img/feature-02.078c6bff.png";